import { render, staticRenderFns } from "./setSeparateOut.vue?vue&type=template&id=5247883a&scoped=true&"
import script from "./setSeparateOut.vue?vue&type=script&lang=js&"
export * from "./setSeparateOut.vue?vue&type=script&lang=js&"
import style0 from "./setSeparateOut.vue?vue&type=style&index=0&id=5247883a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5247883a",
  null
  
)

component.options.__file = "setSeparateOut.vue"
export default component.exports